<template>
    <span>
        <span v-if="isRender">
            <v-icon-button :disabled="current === 1" @click="handleClick(current - 1)">
                chevron_left
            </v-icon-button>

            <span v-for="page, index in middle" :key="index">
                <span v-if="page === null" v-margin.left="2" v-margin.right="2">. . .</span>
                <v-button v-else :flat="page !== current" :primary="page === current" @click="handleClick(page)">
                    {{ page }}
                </v-button>
            </span>
    
            <v-icon-button :disabled="current === pages" @click="handleClick(current + 1)">
                chevron_right
            </v-icon-button>
        </span>
    </span>
</template>
<script>
    import { vButton, vIconButton } from '../Button';
    import theme from './pagination.scss';

    export default {
        name: 'pagination',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                },
            },
            total: Number,
            display: Number,
            current: Number,
        },
        components: {
            vButton,
            vIconButton,
        },
        computed: {
            pages() {
                return Math.ceil(this.total / this.display);
            },
            middle() {
                switch (true) {
                    case this.pages <= 7:
                        return Array(7)
                            .fill(null)
                            .map((p, index) => index + 1)
                            .filter((page) => page <= this.pages);
                    case this.current <= 4:
                        return [
                            1, 2, 3, 4, 5,
                            null, this.pages
                        ];
                    case this.current >= this.pages - 3:
                        return [
                            1, null,
                            this.pages - 4,
                            this.pages - 3,
                            this.pages - 2,
                            this.pages - 1,
                            this.pages,
                        ];
                    default:
                        return [
                            1, null,
                            this.current - 1,
                            this.current,
                            this.current + 1,
                            null, this.pages
                        ];
                }
            },
            isRender() {
                return this.pages > 1;
            }
        },
        methods: {
            handleClick(page) {
                this.$emit('click', page);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Pagination.vue?79798b47